import { useContext } from 'react';
import { CarrierContext } from '../Context/CarrierContext';
import { text } from '../Localization/Localizer';

export function useGetAdvisorTitleFallback(): string {
  const { carrierInfo } = useContext(CarrierContext);

  return carrierInfo.useAdvisorTitleFallback ? text('home.advisorTitle') : '';
}
